import axios from 'axios';
import { getBaseUrl } from './dataApi';

const baseUrl = getBaseUrl();
const helpUrl = `${baseUrl}/help`;

const authHeaders = (accessToken) => ({
  'Authorization': `Bearer ${accessToken}`,
  'Content-type': 'application/json',
});

// Articles
export const getArticles = async (accessToken) => {
  try {
    const response = await axios({ method: 'GET', url: `${helpUrl}/articles`, headers: authHeaders(accessToken) });
    return response;
  } catch (error) { return error; }
};

export const getArticle = async (articleId, accessToken) => {
  try {
    const response = await axios({ method: 'GET', url: `${helpUrl}/articles/${articleId}`, headers: authHeaders(accessToken) });
    return response;
  } catch (error) { return error; }
};

// FAQ
export const getFaq = async (accessToken) => {
  try {
    const response = await axios({ method: 'GET', url: `${helpUrl}/faq`, headers: authHeaders(accessToken) });
    return response;
  } catch (error) { return error; }
};

// Videos
export const getVideos = async (accessToken) => {
  try {
    const response = await axios({ method: 'GET', url: `${helpUrl}/videos`, headers: authHeaders(accessToken) });
    return response;
  } catch (error) { return error; }
};

// Release Notes
export const getReleaseNotes = async (accessToken) => {
  try {
    const response = await axios({ method: 'GET', url: `${helpUrl}/release-notes`, headers: authHeaders(accessToken) });
    return response;
  } catch (error) { return error; }
};

// Search
export const searchContent = async (query, accessToken) => {
  try {
    const response = await axios({ method: 'GET', url: `${helpUrl}/search`, params: { q: query }, headers: authHeaders(accessToken) });
    return response;
  } catch (error) { return error; }
};

// Feedback
export const submitFeedback = async (feedbackData, accessToken) => {
  try {
    const response = await axios({ method: 'POST', url: `${helpUrl}/feedback`, data: feedbackData, headers: authHeaders(accessToken) });
    return response;
  } catch (error) { return error; }
};

// Onboarding
export const getOnboardingStatus = async (accessToken) => {
  try {
    const response = await axios({ method: 'GET', url: `${helpUrl}/onboarding/status`, headers: authHeaders(accessToken) });
    return response;
  } catch (error) { return error; }
};

export const markOnboardingStep = async (stepKey, accessToken) => {
  try {
    const response = await axios({ method: 'POST', url: `${helpUrl}/onboarding/step/${stepKey}`, headers: authHeaders(accessToken) });
    return response;
  } catch (error) { return error; }
};

// Tour Progress
export const getTourProgress = async (accessToken) => {
  try {
    const response = await axios({ method: 'GET', url: `${helpUrl}/tour/progress`, headers: authHeaders(accessToken) });
    return response;
  } catch (error) { return error; }
};

export const saveTourProgress = async (tourId, lastStepIndex, accessToken) => {
  try {
    const response = await axios({ method: 'POST', url: `${helpUrl}/tour/progress`, data: { tour_id: tourId, last_step_index: lastStepIndex }, headers: authHeaders(accessToken) });
    return response;
  } catch (error) { return error; }
};

// Release Notes mark-seen
export const markReleaseNotesSeen = async (accessToken) => {
  try {
    const response = await axios({ method: 'POST', url: `${helpUrl}/release-notes/mark-seen`, headers: authHeaders(accessToken) });
    return response;
  } catch (error) { return error; }
};

// AI Assistant — removed pre-launch, planned for future release
// export const sendAiMessage = ...

// Admin helpers
export const adminUploadImage = async (file, accessToken) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios({ method: 'POST', url: `${helpUrl}/admin/upload-image`, data: formData, headers: { 'Authorization': `Bearer ${accessToken}` } });
    return response;
  } catch (error) { return error; }
};

// Admin article helpers
export const adminCreateArticle = async (data, accessToken) => {
  try {
    const response = await axios({ method: 'POST', url: `${helpUrl}/admin/articles`, data, headers: authHeaders(accessToken) });
    return response;
  } catch (error) { return error; }
};

export const adminUpdateArticle = async (id, data, accessToken) => {
  try {
    const response = await axios({ method: 'PUT', url: `${helpUrl}/admin/articles/${id}`, data, headers: authHeaders(accessToken) });
    return response;
  } catch (error) { return error; }
};

export const adminDeleteArticle = async (id, accessToken) => {
  try {
    const response = await axios({ method: 'DELETE', url: `${helpUrl}/admin/articles/${id}`, headers: authHeaders(accessToken) });
    return response;
  } catch (error) { return error; }
};

export const adminPublishArticle = async (id, accessToken) => {
  try {
    const response = await axios({ method: 'POST', url: `${helpUrl}/admin/articles/${id}/publish`, headers: authHeaders(accessToken) });
    return response;
  } catch (error) { return error; }
};

// Admin FAQ helpers
export const adminCreateFaq = async (data, accessToken) => {
  try {
    const response = await axios({ method: 'POST', url: `${helpUrl}/admin/faq`, data, headers: authHeaders(accessToken) });
    return response;
  } catch (error) { return error; }
};

export const adminUpdateFaq = async (id, data, accessToken) => {
  try {
    const response = await axios({ method: 'PUT', url: `${helpUrl}/admin/faq/${id}`, data, headers: authHeaders(accessToken) });
    return response;
  } catch (error) { return error; }
};

export const adminDeleteFaq = async (id, accessToken) => {
  try {
    const response = await axios({ method: 'DELETE', url: `${helpUrl}/admin/faq/${id}`, headers: authHeaders(accessToken) });
    return response;
  } catch (error) { return error; }
};

// Admin video helpers
export const adminCreateVideo = async (data, accessToken) => {
  try {
    const response = await axios({ method: 'POST', url: `${helpUrl}/admin/videos`, data, headers: authHeaders(accessToken) });
    return response;
  } catch (error) { return error; }
};

export const adminUpdateVideo = async (id, data, accessToken) => {
  try {
    const response = await axios({ method: 'PUT', url: `${helpUrl}/admin/videos/${id}`, data, headers: authHeaders(accessToken) });
    return response;
  } catch (error) { return error; }
};

export const adminDeleteVideo = async (id, accessToken) => {
  try {
    const response = await axios({ method: 'DELETE', url: `${helpUrl}/admin/videos/${id}`, headers: authHeaders(accessToken) });
    return response;
  } catch (error) { return error; }
};

// Admin release notes helpers
export const adminCreateReleaseNote = async (data, accessToken) => {
  try {
    const response = await axios({ method: 'POST', url: `${helpUrl}/admin/release-notes`, data, headers: authHeaders(accessToken) });
    return response;
  } catch (error) { return error; }
};

export const adminUpdateReleaseNote = async (id, data, accessToken) => {
  try {
    const response = await axios({ method: 'PUT', url: `${helpUrl}/admin/release-notes/${id}`, data, headers: authHeaders(accessToken) });
    return response;
  } catch (error) { return error; }
};

// Admin feedback summary
export const adminGetFeedbackSummary = async (accessToken) => {
  try {
    const response = await axios({ method: 'GET', url: `${helpUrl}/admin/feedback-summary`, headers: authHeaders(accessToken) });
    return response;
  } catch (error) { return error; }
};

// Onboarding step fire-and-forget helper
// Call this after successful actions to auto-mark onboarding steps complete.
// Silently ignores errors so it never disrupts the main action.
export const fireOnboardingStep = (stepKey, accessToken) => {
  if (!accessToken || !stepKey) return;
  markOnboardingStep(stepKey, accessToken).catch(() => {});
};
